import React from 'react';
import { Button } from '@mui/material';

interface UseCreateButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const useCreateButton = ({ 
  label, 
  onClick, 
  className = "", 
  style = {} 
}: UseCreateButtonProps) => {
  const CreateButton: React.FC = () => (
    <Button 
      className={`px-4 py-2 rounded fw-medium text-white d-flex align-items-center ${className}`}
      style={{ 
        backgroundColor: 'rgba(13,44,90,1)',
        ...style 
      }}
      onClick={onClick}
    >
      <span 
        className="me-2 rounded-circle bg-white d-flex align-items-center justify-content-center fw-bold" 
        style={{ width: 20, height: 20, fontSize: 14, color: 'rgba(13,44,90,1)' }}
      >
        +
      </span>
      {label}
    </Button>
  );

  return { CreateButton };
};

export default useCreateButton;
